module.exports = __webpack_public_path__ + "static/media/Ginkolet.f709b875.jpg";